import React, { VFC, useEffect } from 'react';

import { Switch, Route, Redirect } from 'react-router-dom';

import { useAppDispatch } from './hooks';
import { getChains } from './redux/slices/bridgeSlice';
import Bridge from './pages/bridge/Bridge';
import SceneHistory from './pages/SceneHistory';
import ModalTimeoutLogout from './components/ModalTimeoutLogout';
import ErrorBoundary from './components/common/errorBoundary/ErrorBoundary';
import SceneError from './pages/SceneError';
import SceneTemporary from './pages/SceneTemporary';
import useServiceOnOff from './hooks/useServiceOnOff';

const App: VFC = () => {
  const isServiceOff = useServiceOnOff();
  const dispatch = useAppDispatch();

  useEffect(() => {
    new window.WOW().init();
  }, [dispatch]);

  useEffect(() => {
    dispatch(getChains());
  }, [dispatch]);

  return (
    <ErrorBoundary>
      <Switch>
        {isServiceOff ? (
          <Route exact path="*" component={SceneTemporary} />
        ) : (
          <>
            <Route exact path="/bridge" component={Bridge} />
            <Route exact path="/history" component={SceneHistory} />
            <Route exact path="/404error" component={SceneError} />

            {/* <Route exact path="/bridge" component={SceneTemporary} /> */}
            {/* <Route exact path="/history" component={SceneTemporary} /> */}
            {/* <Route exact path="/bridge" component={SceneTemporary} /> */}
            {/* <Route exact path="/history" component={SceneTemporary} /> */}

            <Route exact path="/">
              <Redirect to="/bridge" />
            </Route>
            <Route path="*">
              <Redirect to="/bridge" />
            </Route>
            <Route path="/bridge">
              <Redirect to="/bridge" />
            </Route>
            <Route path="/history">
              <Redirect to="/history" />
            </Route>
            {/* <Route path="/temporary">
          <Redirect to="/temporary" />
        </Route> */}
          </>
        )}
      </Switch>
      <ModalTimeoutLogout />
    </ErrorBoundary>
  );
};

export default App;
